import { Container, IInit } from '../../../common/container/Container'
import { Observable } from 'rxjs'
import { IStatusService } from '../../../common/status/StatusService'
import { STATUS_SERVICE_KEY } from '../../../container/app'
import { map } from 'rxjs/operators'
import { State, StateDTO, toModel } from '../models/State'
import { IStateApi } from '../api/StateApi'

type Props = {
  apiKey: symbol
}

export interface IStateService extends IInit {
  getByID(id: string): Observable<State>

  getAll(): Observable<State[] | undefined>

  add(e: StateDTO): Observable<State | undefined>

  update(e: StateDTO): Observable<State | undefined>
}

export class StateService implements IStateService {
  private readonly _apiKey: symbol
  private _container!: Container
  private _api!: IStateApi
  private _statusService!: IStatusService

  constructor(p: Props) {
    this._apiKey = p.apiKey
  }

  init(c: Container) {
    this._container = c
    this._api = this._container.get<IStateApi>(this._apiKey)
    this._statusService = this._container.get<IStatusService>(STATUS_SERVICE_KEY)
  }

  add(e: StateDTO): Observable<State | undefined> {
    return this._api.add(e)
  }

  getByID(id: string): Observable<State> {
    return this._api.getByID(id)
  }

  update(e: StateDTO): Observable<State | undefined> {
    return this._api.update(e)
  }

  getAll(): Observable<State[] | undefined> {
    let all = this._api.getAll()
    return all.pipe(map(res => res?.items.map(i => toModel(i))))
  }
}
